const CategoriasMenu = Object.freeze({
  PAINEL: 0,
  PACIENTES: 1,
  USUARIO: 2,
  SESSAO: 3
});

export default CategoriasMenu;
